
// /img/payment-schedule.jpg

import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Container, Col, Row } from 'react-bootstrap'
import SharedTitle from '~/components/UI/SharedTitle'
import Text from '~/components/UI/Text'
import { useTranslation } from '~/i18n'
import Box from '~/components/UI/Box'
import Icon from '~/components/UI/Icon'
import { COLORS } from '~/components/UI/Constants'
import appendCDN from '~/utils/append_cdn_link'
import breakpoints from '~/components/UI/breakpoints'

const MyContainer = styled.div`
  padding: 40px 0;
`

const Img = styled.div`
  background: url(${appendCDN('/img/payment-schedule.jpg')});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 100%;
  height: 500px;
`

const List = styled.ul`
  list-style: none;
  padding: 0;
  li {
    margin-bottom: 8px;
    display: flex;
  }
  p {
    margin-left: 16px;
  }
  span {
    font-size: 16px;
    line-height: 1.6;
    ::before {
      color: ${COLORS.PRIMARY}
    }
  }
`

const Title = styled(SharedTitle)`
  text-align: center;
  ${breakpoints.md} {
    text-align: left;
  }
`

const content = (t: any) => ([
  t`Tiến độ thanh toán theo quy định của chủ đầu tư, thường kéo dài từ 12 đến 36 tháng`,
  t`Lịch thanh toán được thể hiện trong hợp đồng và thông tin dự án`,
  t`Khách hàng vui lòng thanh toán theo tiến độ quy định trong hợp đồng thông qua chuyển khoản hoặc trả trực tiếp`,
  t`Khi sắp đến hạn thanh toán, khách hàng sẽ được thông báo qua email và ứng dụng trên điện thoại`
])

const Section4PaymentSchedule = () => {
  const [t] = useTranslation()
  const _content = useMemo(() => content(t), [])
  const list = useMemo(() => {
    return _content.map(item => (
      <li key={item}>
        <Icon name='o-check' />
        <Text>
          {item}
        </Text>
      </li>
    ))
  }, [_content])

  return (
    <MyContainer>
      <Container>
        <Row>
          <Col md={6} style={{ padding: 0 }}>
            <Box column flex justify='center'>
              <Title padding='0 0 40px 0'>
                {t`Thanh toán theo tiến độ`}
              </Title>
              <List>
                {list}
              </List>
            </Box>
          </Col>
          <Col md={6}>
            <Img />
          </Col>
        </Row>
      </Container>
    </MyContainer>
  )
}

export default Section4PaymentSchedule
